<template>
	<div class="orderDate">
		<!-- 订单状态标题及编号、时间 -->
		<div class="order-header">
			<div class="tle flex-c">
				<h2 class="tit-30 fw700">订单详情</h2>
				<div class="tag tit-12">
					<span class="span0" v-if="shu.zhuangtai == 0">待付款</span>
					<span class="span1" v-if="shu.zhuangtai == 10">待发货</span>
					<span class="span2" v-if="shu.zhuangtai == 20">待收货</span>
					<span class="span3" v-if="shu.zhuangtai == 30">已完成</span>
					<span class="span0" v-if="shu.zhuangtai ==5">已取消</span>
				</div>
			</div>

			<div class="text mt-20 tit-14">
				<p>订单号：{{ shu.dingdanhao }}</p>
				<p>下单时间：{{ shu.xiadanshijian }}</p>
			</div>
		</div>

		<!-- 订单状态流程 -->
		<el-steps :active="shu.stepsactive" align-center finish-status="success" class="order-steps">
			<el-step title="买家已下单" :description="shu.xiadanshijian"></el-step>
			<el-step title="待付款" ></el-step>
			<el-step title="待发货"></el-step>
			<el-step title="待收货"></el-step>
		</el-steps>

		<!-- 配送信息、支付方式、发票 模块 -->

		<div class="order_info">
			<div class="item itemOne">
				<div class="tit tit-18 fw700">配送信息</div>
				<div class="list">
					<p>
						<span class="dot">收件人：</span>
						<span class="sp2">{{shu.shouhuoren}} </span>
					</p>
					<p>
						<span class="dot">联系电话：</span>
						<span class="sp2">{{shu.shouhuodianhua}} </span>
					</p>
					<p>
						<span class="dot">配送地址：</span>
						<span class="sp2">{{shu.shouhuodizhi}} </span>
					</p>
				</div>
			</div>
			<div class="item">
				<div class="tit tit-18 fw700">支付方式</div>
				<div class="pay">
					<div v-if="shu.zhifuqudao == 'yu_e'">
						<div class="icBox flex-cc mr-10">
							<svg viewBox="0 0 1228 1024" version="1.1" width="20" height="20">
								<path
									d="M530.8928 703.1296a41.472 41.472 0 0 1-35.7376-19.8144l-2.7136-5.5808L278.272 394.752a18.7392 18.7392 0 0 1-2.048-8.1408 19.968 19.968 0 0 1 20.48-19.3536c4.608 0 8.8576 1.4336 12.288 3.84l234.3936 139.9296a64.4096 64.4096 0 0 0 54.528 5.9392L1116.2624 204.8C1004.9536 80.896 821.76 0 614.4 0 275.0464 0 0 216.576 0 483.6352c0 145.7152 82.7392 276.8896 212.2752 365.5168a38.1952 38.1952 0 0 1 17.2032 31.488 44.4928 44.4928 0 0 1-2.1504 12.3904l-27.6992 97.4848c-1.3312 4.608-3.328 9.3696-3.328 14.1312 0 10.752 9.216 19.3536 20.48 19.3536 4.4032 0 8.0384-1.536 11.776-3.584l134.5536-73.3184c10.1376-5.5296 20.7872-8.96 32.6144-8.96 6.2976 0 12.288 0.9216 18.0736 2.5088 62.72 17.0496 130.4576 26.5728 200.5504 26.5728C953.7024 967.168 1228.8 750.592 1228.8 483.6352c0-80.9472-25.4464-157.1328-70.0416-224.1024l-604.9792 436.992-4.4544 2.4064a42.1376 42.1376 0 0 1-18.432 4.1984z"
									fill="#15BA11"></path>
							</svg>
						</div>
						<span class="tit-15 cor-5C5C"> {{ shu.zhifuqudao_wenzi }}</span>
					</div>
					<div v-if="shu.zhifuqudao == 'xianxia'">
						<div class="icBox flex-cc mr-10">
							<el-image style="width: 30px;height: 30px;" src="https://youliqi.hnydl.com.cn/gongyong/shangchuan/tu/33/2026/03/a75Wt48W844GGNz4Lw4yW87WhWcCZK.png" fit="contain"></el-image>
						</div>
						<span class="tit-15 cor-5C5C"> {{ shu.zhifuqudao_wenzi }}</span>
					</div>
					<div v-if="shu.zhifuqudao== 'zhifubao'">
						<div class="icBox flex-cc mr-10">
							<svg viewBox="0 0 1024 1024" version="1.1" width="20" height="20">
								<path
									d="M230.771014 576.556522c-12.614493 9.646377-25.228986 23.744928-28.93913 42.295652-5.194203 24.486957-0.742029 55.652174 22.26087 80.13913 28.93913 28.93913 72.718841 37.101449 92.011594 38.585508 51.2 3.710145 106.110145-22.26087 147.663768-50.457971 16.324638-11.130435 43.77971-34.133333 70.492754-69.750725-59.362319-30.423188-133.565217-64.556522-212.22029-61.588406-41.553623 1.484058-70.492754 9.646377-91.269566 20.776812zM983.188406 712.347826c25.971014-61.588406 40.811594-129.113043 40.811594-200.347826 0-281.971014-230.028986-512-512-512S0 230.028986 0 512s230.028986 512 512 512c170.666667 0 321.298551-83.849275 414.794203-212.22029C838.492754 768.742029 693.797101 696.023188 604.011594 652.985507c-42.295652 48.973913-105.368116 97.205797-176.602898 117.982609-44.521739 13.356522-85.333333 18.550725-126.886957 9.646377-42.295652-8.904348-72.718841-28.197101-90.527536-47.489855-8.904348-10.388406-19.292754-22.26087-27.455073-37.843479 0.742029 0.742029 0.742029 2.226087 0.742029 2.968116 0 0-4.452174-7.42029-7.420289-19.292753-1.484058-5.936232-2.968116-11.872464-3.710145-17.808696-0.742029-4.452174-0.742029-8.904348 0-12.614493-0.742029-7.42029 0-15.582609 1.484058-23.744927 4.452174-20.776812 12.614493-43.77971 35.617391-65.298551 48.973913-48.231884 115.014493-50.457971 149.147826-50.457971 50.457971 0.742029 138.017391 22.26087 212.22029 48.973913 20.776812-43.77971 34.133333-89.785507 42.295652-121.692754H304.973913v-33.391304h158.052174v-66.782609H272.324638v-34.133333h190.701449v-66.782609c0-8.904348 2.226087-16.324638 16.324638-16.324637h74.944927v83.107246h207.026087v33.391304H554.295652v66.782609H719.768116S702.701449 494.933333 651.501449 586.202899c115.014493 40.811594 277.518841 104.626087 331.686957 126.144927z m0 0"
									fill="#06B4FD"></path>
							</svg>
						</div>
						<span class="tit-15 cor-5C5C">{{ shu.zhifuqudao_wenzi }}</span>
					</div>
				</div>
			</div>

			<div class="item">
				<div class="tit tit-18 fw700">发票</div>
				<div class="invoice" v-if="shu.xuyaofapiao ==0">
					<div class="info">
						<div class="tit1 tit-12 cor-8080">企业数电普票</div>
						<div class="tit2 tit-14 cor-000">
							<span class="line1">{{shu.fapiaoxq.invoiceTitle }}</span>
						</div>
						<div class="tit3 tit-12 cor-8080">
							<span class="line1">{{shu.fapiaoxq.taxNumber }}</span>
						</div>
					</div>
				</div>

				<div class="noInvoice" v-else>
					<div class="tit-15 cor-8080">不需要发票</div>
				</div>
			</div>
		</div>

		<!-- 商品清单表格 -->
		<el-table :data="shu.shangpin" style="width: 100%" class="product-table">
			<el-table-column prop="name" label="商品名称" width="300">
				<template slot-scope="scope">
					<div class="product-info flex-c">
						<div class="imgBox">
							<el-image :src="scope.row.tu"></el-image>
						</div>
						<div class="product-name fw700">{{ scope.row.ming }}</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="jiage" label="价格">
				<template slot-scope="scope">
					<div class="price cor-333">¥{{ scope.row.jiage }}</div>
				</template>
			</el-table-column>
			<el-table-column prop="shuliang" label="数量">
				<template slot-scope="scope">
					<div class="quantity cor-333">{{ scope.row.shuliang }}</div>
				</template>
			</el-table-column>
			<el-table-column prop="zongjia" label="小计">
				<template slot-scope="scope">
					<div class="subtotal cor-333">¥{{ scope.row.zongjia }}</div>
				</template>
			</el-table-column>
		</el-table>

		<!-- 金额计算与操作 -->
		<div class="amount-box">
			<el-row>
				<el-col class="amount-info">
					<div class="item">
						<span class="sp1">商品总价：</span>
						<span class="sp2">¥{{ shu.zongjia }}</span>
					</div>
					<div class="item">
						<span class="sp1">运费： </span>
						<span class="sp2"> ¥{{ shu.yunfei }} </span>
					</div>

					<div class="item">
						<span class="sp1">优惠：</span>
						<span class="sp2">¥{{ shu.quan_e }} </span>
					</div>

					<div class="item total">
						<span class="sp1 fw700">应付金额：</span>
						<span class="sp2">¥{{shu.zongjia}} </span>
					</div>
				</el-col>
			</el-row>
			<el-row v-if="shu.zhuangtai==0">
				<el-col class="action-buttons">
					<el-button type="default" class="btn1" @click="cancelOrder">取消订单</el-button>
					<el-button v-if="shu.zfstatus==0" type="primary" class="btn2" @click="payNow">立即付款</el-button>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
	export default {
		name: "orderDetails",
		data() {
			return {
				orderInfo: {
					id: 1,
					orderStatus: 0,
					orderNo: "op438401881052545024",
					createTime: "2025-04-24 18:12:33",
					receiverName: "张一明",
					receiverPhone: "15762954123",
					deliveryAddress: "天津市 天津市 河东区 23幢304",
					paymentMethod: "微信支付",
					invoiceStatus: 1,
					invoice: {
						invoiceTit: "张一明",
						taxNumber: "123456789",
					},
					productList: [{
						id: 1,
						img: require("@/assets/navTwo-img.png"),
						name: "自适应智能夹爪 UniGripper",
						price: "2188.00",
						quantity: "x1",
						subtotal: "4376.00",
					}, ],
					totalAmount: "4376.00",
					freight: "0",
					discount: "0",
					payAmount: "4376.00",
					dingdanid: '',
				},
				shu:{}
			};
		},
		created() {
			if (this.$route.params && this.$route.params.id) {
				this.dingdanid = this.$route.params.id;
			}
			this.CSH()
		},
		computed: {},
		methods: {
			CSH() {
				var that = this
				that.$post("m=limitao&k=dingdan&c=Xiangqing", {
					id: that.dingdanid
				}, function(shu) {
					if (shu.shi == 1) {
						that.shu=shu.shu
					}
				})
			},
			cancelOrder() {
				var that = this
				// 取消订单逻辑，比如调用接口标记订单为取消等
				that.$confirm("确定取消订单吗？", "提示", {
						type: "warning",
					})
					.then(() => {
						// 这里可补充实际接口请求，示例仅提示
						that.$post('m=limitao&k=dingdan&c=quxiao',{dingdanid: that.shu.id},function(shu){
							if(shu.shi==1){ 
								that.CSH();
								that.dialogVisible=false
								that.$message({
									type: "success",
									message: "订单取消成功!",
								});
							}
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消操作",
						});
					});
			},
			payNow() {
				// 立即付款逻辑，比如跳转到支付页面、调用支付接口等
				this.$message.success("跳转到支付页面...");
				// 实际可补充：window.location.href = '支付页面地址'  或调用支付 SDK 等
			},
		},
	};
</script>
<style lang="less" scoped>
	.orderDate {
		.order-header {
			padding-bottom: 0.15rem;
			border-bottom: 1px solid #e9e9e9;

			.tag {
				margin-left: 0.15rem;

				span {
					position: relative;
					background: #f0f0f0;
					line-height: 1;
					padding: 0.1rem 0.2rem 0.1rem 0.33rem;
					border-radius: 100px;
					color: #fd0000;

					&::before {
						content: "";
						position: absolute;
						top: 50%;
						left: 0.2rem;
						transform: translateY(-50%);
						width: 5px;
						height: 5px;
						border-radius: 50%;
						background: #f10000;
					}

					&.span1 {
						background: #f0f0f0;
						color: #44d2ff;

						&::before {
							background: #44d2ff;
						}
					}

					&.span2 {
						color: #1d5ad8;

						&::before {
							background: #1d5ad8;
						}
					}

					&.span3 {
						color: #67c23a;

						&::before {
							background: #67c23a;
						}
					}
				}
			}

			.text p {
				line-height: 1.8;
				color: #646464;
			}
		}

		// 订单流程
		/deep/ .order-steps {
			width: 80%;
			margin: 0.5rem auto;

			.el-step__head {
				.el-step__icon {
					position: relative;
					z-index: 1;
					width: 28px;

					&::after {
						content: "";
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						width: 180%;
						height: 180%;
						border-radius: 50%;
						background: #fff;
						z-index: -1;
					}
				}

				.el-step__icon-inner {
					width: 24px;
					height: 24px;
					border-radius: 50%;
					line-height: 20px;
					text-align: center;
					background: #c7c6cb;
					color: #fff;
					border: 2px solid transparent;
				}

				&.is-success {
					.el-step__icon-inner {
						background: none;
						border-color: #1d5ad8;
						color: #1d5ad8;
					}
				}
			}

			.el-step__main {
				.el-step__title.is-success {
					color: #333;
					font-weight: 700;
				}

				.el-step__description.is-success {
					color: #b3b3b3;
					font-size: 12px;
				}
			}
		}

		.order_info {
			padding: 0.4rem 0.3rem;
			background: #f5f5f5;
			display: flex;
			justify-content: space-between;

			.item {
				width: 25%;

				&.itemOne {
					width: 45%;
				}

				.tit {
					margin-bottom: 0.3rem;
				}

				.list {
					p {
						margin-bottom: 0.1rem;
						color: #666666;
						display: flex;

						.dot {
							width: 80px;
							display: inline-block;
						}

						.sp2 {
							flex: 1;
							margin-left: 0.4rem;
						}
					}
				}

				.pay>div {
					display: flex;
					align-items: center;
				}

				.invoice {
					.info {
						background: #fcfcfc;
						border-radius: 0.1rem;
						margin: 0;
						padding: 0.1rem;
						border: 1px solid transparent;
						overflow: hidden;

						.tit2 {
							margin: 0.1rem 0;
						}
					}
				}
			}
		}

		/deep/ .product-table {
			margin-top: 0.3rem;

			.el-table__header {
				.el-table__cell {
					background: #f5f5f5;
					color: #333333;
					font-weight: 700;

					.cell {
						padding: 0 0.3rem;
					}
				}
			}

			.el-table__body {
				td.el-table__cell>.cell {
					padding: 0 0.3rem;
					white-space: nowrap;
				}

				td .product-info {
					.imgBox {
						height: 0.7rem;
						height: 0.7rem;
						margin-right: 0.2rem;
						flex-shrink: 0;

						.el-image {
							width: 100%;
							height: 100%;

							img {
								object-fit: contain;
							}
						}
					}
				}
			}
		}

		.amount-box {
			text-align: right;
			margin-top: 0.3rem;

			.amount-info {
				.item {
					display: flex;
					justify-content: flex-end;
					font-size: var(--font14);
					color: #333;
					line-height: 1.8;

					.sp1 {
						width: 90px;
						margin-right: 0.3rem;
					}

					.sp2 {
						width: 80px;
					}

					&.total {
						font-size: var(--font18);
						font-weight: 700;
						margin-top: 0.2rem;

						.sp2 {
							font-weight: normal;
							color: #c30000;
						}
					}
				}
			}

			/deep/ .action-buttons {
				margin-top: 0.3rem;

				button {
					font-size: var(--font14);
					border-radius: 100px;
					border: 0;
					transition: 0.5s;
				}

				.btn1 {
					background: rgba(227, 227, 227, 0.5);
					padding: 0.13rem 0.28rem;
					color: #a2a2a2;
					margin-right: 0.2rem;

					&:hover {
						background: linear-gradient(-41deg, #001ff5 0%, #41b9e0 100%);
						color: #fff;
					}
				}

				.btn2 {
					background: linear-gradient(-41deg, #001ff5 0%, #41b9e0 100%);
					padding: 0.13rem 0.28rem;
					color: #fff;

					&:hover {
						box-shadow: 0 2px 12px 0 #001ff5;
					}
				}
			}
		}
	}
</style>